var map = {
	"./amazon-icon.svg": 8359,
	"./amazon-logo.png": 53831,
	"./american-express-colored.svg": 20151,
	"./blur-shadow-image.svg": 46989,
	"./blurred-drop-shadow.svg": 79962,
	"./calendar-example.png": 65348,
	"./canva-logo.svg": 74476,
	"./canva.svg": 48244,
	"./check.svg": 96729,
	"./clone.svg": 68698,
	"./crossword-default-thumb.png": 34892,
	"./crossword-example.png": 92534,
	"./customily-full-logo.svg": 18996,
	"./customily-logo-white.svg": 2402,
	"./customily-logo.png": 23102,
	"./diners-club-colored.svg": 67376,
	"./discover-colored.svg": 96603,
	"./drop-shadow-image.svg": 35225,
	"./drop-shadow.svg": 88941,
	"./dynamic-vector.svg": 12982,
	"./dynamic_image.png": 63998,
	"./etsy-logo.png": 16614,
	"./etsy-logo.svg": 360,
	"./generic.svg": 3058,
	"./google-logo.png": 47360,
	"./import-start.svg": 26855,
	"./jcb-colored.svg": 37241,
	"./library-details-image-background.svg": 36786,
	"./loader.gif": 77049,
	"./master-card-colored.svg": 46297,
	"./page.svg": 79526,
	"./pencil.svg": 15008,
	"./photo-example.png": 29810,
	"./photoshop.svg": 35449,
	"./preview-bg-color-example.png": 63904,
	"./preview-img-example.png": 95832,
	"./print-area-customily.png": 17238,
	"./print-area-printful.png": 58011,
	"./print-area-printify.png": 35740,
	"./redo-arrow.svg": 64603,
	"./reviews/happy_paws.svg": 91023,
	"./reviews/incredible_cookies.svg": 21488,
	"./reviews/mothers_family_rings.svg": 83514,
	"./reviews/one_and_only_prints.svg": 59437,
	"./reviews/wunsch_kalender.svg": 7226,
	"./shopify-logo.svg": 48597,
	"./sparkle.svg": 80379,
	"./template.svg": 29917,
	"./tiktok-logo.svg": 77139,
	"./trash.svg": 18339,
	"./undo-arrow.svg": 66085,
	"./unionpay-colored.svg": 40503,
	"./vector-example.svg": 67759,
	"./vector_image.png": 49140,
	"./visa-colored.svg": 37081,
	"./woocommerce-logo.png": 55235,
	"./wordcloud-example.png": 19701,
	"./wordsearch-example.png": 68250,
	"./x.svg": 61345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;